export default {
  // I believe this is totally deprecated
  filterParams(filterType) {
    return {};
  },
};
